module.exports = __webpack_public_path__ + "static/img/nav7.ea87e695.svg";